import type { ReactNode } from "react";

export function AuthFrame({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center px-5 py-12">
      <div className="w-full max-w-[400px] rounded-panel border border-border bg-surface p-8">
        <p className="mb-6 text-[18px] font-bold tracking-[-0.03em]">Weply</p>
        <h1 className="text-[22px] font-bold tracking-[-0.02em]">{title}</h1>
        {subtitle ? (
          <p className="mb-6 mt-1 text-[13px] text-muted">{subtitle}</p>
        ) : (
          <div className="mb-6" />
        )}
        {children}
      </div>
    </div>
  );
}

export function messageOf(error: unknown, fallback: string): string {
  return error instanceof Error && error.message ? error.message : fallback;
}
